
export const FILE_PATH = 'https://pmay-urban.gov.in/drmc' //'https://apis.pmayu-drmc.in/v1' //
//export const API_URL = process.env.NODE_ENV === 'development' ? 'https://192.168.137.85:8081' : 'https://dashboard.pmay-urban.gov.in/v1'
 export const API_URL = process.env.NODE_ENV === 'development' ? 'https://localhost:8081' : 'https://dashboard.pmay-urban.gov.in/v1'
  
